import AES from 'crypto-js/aes';
import ENC from 'crypto-js/enc-utf8';
import CryptoJS from 'crypto-js';
import {UserModel} from '../app/modules/auth';
import {UserRolesEnum} from '../app/modules/models-management/types';
import heic2any from 'heic2any';
import axios from 'axios';

/* eslint-disable no-template-curly-in-string */
export const randomIntFromInterval = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const parseError = (error: any) => {
  return typeof error === 'string'
    ? error
    : error?.response?.data?.msg || error?.msg || error?.message;
};

export const getEmbedCodeUrl = (pub_id: string) => {
  const embed_code =
    '<a href="javascript:window.open( \'' +
    process.env.REACT_APP_APP_URL +
    '/models/ar-app?id=' +
    pub_id +
    '\', \'\', `height=${screen.availHeight * 0.8},width=${(screen.availHeight * 0.8) / (16 / 9)},toolbar=no,directories=no,status=no, linemenubar=no,scrollbars=no,resizable=yes ,modal=yes` );;" rel="noopener noreferrer" style=" background: rgb(83, 122, 252); color: white; padding: 10px 15px; border-radius: 13px; text-decoration: none; " > <span style="position: relative; top: 7px; padding-right: 5px" ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > <path opacity="0.3" d="M3 6C2.4 6 2 5.6 2 5V3C2 2.4 2.4 2 3 2H5C5.6 2 6 2.4 6 3C6 3.6 5.6 4 5 4H4V5C4 5.6 3.6 6 3 6ZM22 5V3C22 2.4 21.6 2 21 2H19C18.4 2 18 2.4 18 3C18 3.6 18.4 4 19 4H20V5C20 5.6 20.4 6 21 6C21.6 6 22 5.6 22 5ZM6 21C6 20.4 5.6 20 5 20H4V19C4 18.4 3.6 18 3 18C2.4 18 2 18.4 2 19V21C2 21.6 2.4 22 3 22H5C5.6 22 6 21.6 6 21ZM22 21V19C22 18.4 21.6 18 21 18C20.4 18 20 18.4 20 19V20H19C18.4 20 18 20.4 18 21C18 21.6 18.4 22 19 22H21C21.6 22 22 21.6 22 21ZM16 11V9C16 6.8 14.2 5 12 5C9.8 5 8 6.8 8 9V11C7.2 11 6.5 11.7 6.5 12.5C6.5 13.3 7.2 14 8 14V15C8 17.2 9.8 19 12 19C14.2 19 16 17.2 16 15V14C16.8 14 17.5 13.3 17.5 12.5C17.5 11.7 16.8 11 16 11ZM13.4 15C13.7 15 14 15.3 13.9 15.6C13.6 16.4 12.9 17 12 17C11.1 17 10.4 16.5 10.1 15.7C10 15.4 10.2 15 10.6 15H13.4Z" fill="currentColor"/> <path d="M9.2 12.9C9.1 12.8 9.10001 12.7 9.10001 12.6C9.00001 12.2 9.3 11.7 9.7 11.6C10.1 11.5 10.6 11.8 10.7 12.2C10.7 12.3 10.7 12.4 10.7 12.5L9.2 12.9ZM14.8 12.9C14.9 12.8 14.9 12.7 14.9 12.6C15 12.2 14.7 11.7 14.3 11.6C13.9 11.5 13.4 11.8 13.3 12.2C13.3 12.3 13.3 12.4 13.3 12.5L14.8 12.9ZM16 7.29998C16.3 6.99998 16.5 6.69998 16.7 6.29998C16.3 6.29998 15.8 6.30001 15.4 6.20001C15 6.10001 14.7 5.90001 14.4 5.70001C13.8 5.20001 13 5.00002 12.2 4.90002C9.9 4.80002 8.10001 6.79997 8.10001 9.09997V11.4C8.90001 10.7 9.40001 9.8 9.60001 9C11 9.1 13.4 8.69998 14.5 8.29998C14.7 9.39998 15.3 10.5 16.1 11.4V9C16.1 8.5 16 8 15.8 7.5C15.8 7.5 15.9 7.39998 16 7.29998Z" fill="currentColor"/> </svg> </span> <span> Try it on your face</span> </a>';

  return embed_code;
};

export const getBase64codeForImage = (binaryStr: string): string => {
  return `data:image/png;base64,${binaryStr?.substring(2, binaryStr?.length - 1)}`;
};

export const setFavIcon = (logoBase64: string) => {
  let link: any = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  link.href = getBase64codeForImage(logoBase64);
};

export const sleep = async (delay: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
};

export const encryptPassword = (password: string) => {
  const secret = process.env.REACT_APP_PWD_SECRET;

  if (!secret) throw new Error('encryption secret is not provided!');

  const secret256 = CryptoJS.enc.Utf8.parse(secret);

  const encParams = AES.encrypt(password, secret256, {
    mode: CryptoJS.mode.ECB,
  });

  // console.log(
  //   `entered pwd: ${password}
  //   \nencrypted pwd: ${encParams.toString()}
  //   \nsecret key: ${secret}
  //   \nsecret key AES-256: ${encParams.key.toString()}
  //   `,
  //   encParams
  // );

  return encParams.toString();
};

export const decryptMessage = (encypt: string) => {
  const secret = process.env.REACT_APP_PWD_SECRET;

  if (!secret) throw new Error('encryption secret is not provided!');

  let bytes;

  try {
    bytes = AES.decrypt(encypt, secret);
    console.log(bytes);
    const decrypted = bytes.toString(ENC);
    return decrypted;
  } catch (err) {
    throw new Error('UNABLE TO decrypt!');
  }
};

export const downloadFile = (apiResponseData: any, fileName: string) => {
  // create file link in browser's memory
  const href = URL.createObjectURL(apiResponseData);

  // create "a" HTML element with href to file & click
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', fileName + '.zip'); //or any other extension
  document.body.appendChild(link);
  link.click();

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

export async function getModelFile(
  url: string,
  token: string | undefined = undefined,
  decrypt: boolean = true
): Promise<string> {
  try {
    var headers = {};
    if (token) {
      headers = {Authorization: `Bearer ${token}`};
    }
    const response = await fetch(url, {
      headers: headers,
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const fileBlob = await response.blob();
    const tempFileUrl = URL.createObjectURL(fileBlob);
    const arrayBuffer = await fileBlob.arrayBuffer();
    const dataView = new DataView(arrayBuffer);
    const JFIFString = 'JFIF';
    const GLBFString = 'glTF';

    if (decrypt) {
      let found = false;
      for (let i = 0; i < JFIFString.length; i++) {
        if (dataView.getUint8(i) !== JFIFString.charCodeAt(i)) {
          found = false;
          break;
        }
        found = true;
      }
      if (found) {
        for (let i = 0; i < GLBFString.length; i++) {
          dataView.setUint8(i, GLBFString.charCodeAt(i));
        }
      } else {
        return tempFileUrl;
      }
    }

    const modifiedBlob = new Blob([arrayBuffer], {type: 'model/gltf-binary'});
    const modifiedFileUrl = URL.createObjectURL(modifiedBlob);
    // Upload the modified file to the server here
    // Delete the temporary file
    URL.revokeObjectURL(tempFileUrl);
    return modifiedFileUrl;
  } catch (error) {
    throw error;
  }
}

export const round = (value: number, precision: number) => {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
};

export const isObjectEmpty = (obj: any) => {
  return JSON.stringify(obj) === '{}';
};

export const isResellerAccount = (user: UserModel | undefined) => {
  if (!user) return false;

  const isResellerCustomer = user.role_id === UserRolesEnum.USER && user.org_id;
  return isResellerCustomer || user.role_id === UserRolesEnum.RESELLER_ADMIN;
};

export function sortArrayAscending<T>(arr: T[]): T[] {
  return arr.slice().sort((a, b) => {
    if (a < b) return 1;
    if (a > b) return -1;
    return 0;
  });
}

export function sumProperty(arr: any[], propertyName: keyof any): number {
  return arr.reduce((total, obj) => total + obj[propertyName], 0);
}

export function toQueryParams(obj: {[key: string]: any}): string {
  return Object.entries(obj)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
}
export function objectToQueryString(params: {[key: string]: any}): string {
  return Object.keys(params)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
    .join('&');
}

export function addPrefixToProperties<T extends Record<string, any>>(
  obj: T,
  prefix: string
): {[K in keyof T as `${typeof prefix}${K & string}`]: T[K]} {
  const result = {} as any;

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[`${prefix}${key}`] = obj[key];
    }
  }

  return result;
}

export function getRandomString(strings: string[]): string {
  const randomIndex = Math.floor(Math.random() * strings.length);
  return strings[randomIndex];
}

export function deepEqual<T>(obj1: T, obj2: T): boolean {
  if (obj1 === obj2) return true;

  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false;
  }

  const keys1 = Object.keys(obj1) as (keyof T)[];
  const keys2 = Object.keys(obj2) as (keyof T)[];

  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

/**
 * Compare two arrays of objects.
 * @param arr1 - The first array of objects to compare.
 * @param arr2 - The second array of objects to compare.
 * @returns True if arrays have the same objects with the same properties, false otherwise.
 */
export function compareArrays<T>(arr1: T[], arr2: T[]): boolean {
  if (arr1.length !== arr2.length) return false;

  for (const obj1 of arr1) {
    const match = arr2.some((obj2) => deepEqual(obj1, obj2));
    if (!match) return false;
  }

  return true;
}

interface DownloadVideoParams {
  videoUrl: string;
  fileName: string;
  onProgress: (progressEvent: ProgressEvent) => void;
}

export async function downloadVideo({videoUrl, fileName, onProgress}: DownloadVideoParams) {
  try {
    // Ensure the URL is valid
    if (!videoUrl) {
      throw new Error('Invalid video URL');
    }

    const response = await axios.create().get(videoUrl, {
      headers: {},
      responseType: 'blob', // This is important to handle binary data
      onDownloadProgress: onProgress,
    });

    // // Fetch the video data
    // const response = await fetch(videoUrl, {
    //   method: 'GET',
    //   credentials: 'include',
    //   headers: {
    //     'Content-Type': 'video/mp4',
    //   },
    // });

    // Check if the response is OK (status code 200-299)
    if (response.status > 210) {
      throw new Error(`Failed to fetch video. Status: ${response.status}`);
    }

    const blob = new Blob([response.data], {type: response.data.type});

    // Create a link element
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${fileName}.mp4`;

    // Append the link to the body
    document.body.appendChild(link);

    // Programmatically click the link to trigger the download
    link.click();

    // Clean up
    window.URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error downloading the video:', error);
  }
}

export function downloadURI(uri: string, name: string) {
  var link = document.createElement('a');
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const getMaxId = (items: any[]): number => {
  return items.reduce((maxId, item) => (item.id > maxId ? item.id : maxId), 0);
};
